import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {IPricesHubDataSource, PRICES_HUB_DATA_SOURCE_COLUMNS} from "../../constants/prices_hub_data_sources";

interface IProps {
    sources: IPricesHubDataSource[];
}

export const PricesHubDataSourcesTable = (props: IProps) => {
    const {sources} = props;

    return (
        <div className={frameStyle}>
            <table className={tableStyle}>
                <thead>
                    <tr>
                        <th scope="col" className={headerCellStyle}>
                            <Text as="span" variant="info_txt_1">
                                {PRICES_HUB_DATA_SOURCE_COLUMNS.source}
                            </Text>
                        </th>
                        <th scope="col" className={headerCellStyle}>
                            <Text as="span" variant="info_txt_1">
                                {PRICES_HUB_DATA_SOURCE_COLUMNS.shows}
                            </Text>
                        </th>
                        <th scope="col" className={headerCellStyle}>
                            <Text as="span" variant="info_txt_1">
                                {PRICES_HUB_DATA_SOURCE_COLUMNS.scope}
                            </Text>
                        </th>
                        <th scope="col" className={headerCellStyle}>
                            <Text as="span" variant="info_txt_1">
                                {PRICES_HUB_DATA_SOURCE_COLUMNS.updateFrequency}
                            </Text>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {sources.map((source) => (
                        <tr key={source.source} className={rowStyle}>
                            <th scope="row" className={sourceCellStyle}>
                                <Text as="span" variant="body_copy_2">
                                    {source.source}
                                </Text>
                            </th>
                            <td className={cellStyle}>
                                <Text as="span" variant="body_copy_2">
                                    {source.shows}
                                </Text>
                            </td>
                            <td className={cellStyle}>
                                <Text as="span" variant="body_copy_2">
                                    {source.scope}
                                </Text>
                            </td>
                            <td className={cellStyle}>
                                <Text as="span" variant="body_copy_2">
                                    {source.updateFrequency}
                                </Text>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const frameStyle = css({
    width: "100%",
    /** Together with the table's 4px border-spacing this adds up to the 16px the design puts above the header. */
    pt: 1.5,
    overflow: "hidden",
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    boxShadow: "0 4px 10px 0 rgba(174, 177, 180, 0.3)"
});

/** The negative margins swallow the outer ring of border-spacing, so the rows reach the card edges. */
const tableStyle = css({
    width: "calc(100% + 0.8rem)",
    mx: "-0.4rem",
    mb: "-0.4rem",
    tableLayout: "fixed",
    borderCollapse: "separate",
    borderSpacing: "0.4rem"
});

const headerCellStyle = css({
    width: "25%",
    height: "3rem",
    px: 1,
    color: "var(--colors-gray-700)",
    textAlign: "center",
    fontWeight: 400,
    verticalAlign: "middle"
});

const cellStyle = css({
    height: "9.2rem",
    px: 1,
    color: "var(--colors-secondary)",
    textAlign: "center",
    verticalAlign: "middle"
});

const sourceCellStyle = css({
    height: "9.2rem",
    px: 1,
    color: "var(--colors-secondary)",
    textAlign: "center",
    fontWeight: 400,
    verticalAlign: "middle"
});

const rowStyle = css({
    "& > th, & > td": {
        backgroundColor: "var(--colors-gray-100)"
    },

    "&:nth-of-type(even) > th, &:nth-of-type(even) > td": {
        backgroundColor: "var(--colors-gray-200)"
    }
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {IPricesHubDataSource, PRICES_HUB_DATA_SOURCE_COLUMNS} from "../../constants/prices_hub_data_sources";

interface IProps {
    sources: IPricesHubDataSource[];
}

export const PricesHubDataSourcesTable = (props: IProps) => {
    const {sources} = props;

    return (
        <div className={frameStyle}>
            <table className={tableStyle}>
                <thead>
                    <tr>
                        <th scope="col" className={headerCellStyle}>
                            <Text as="span" variant="info_txt_1">
                                {PRICES_HUB_DATA_SOURCE_COLUMNS.source}
                            </Text>
                        </th>
                        <th scope="col" className={headerCellStyle}>
                            <Text as="span" variant="info_txt_1">
                                {PRICES_HUB_DATA_SOURCE_COLUMNS.shows}
                            </Text>
                        </th>
                        <th scope="col" className={headerCellStyle}>
                            <Text as="span" variant="info_txt_1">
                                {PRICES_HUB_DATA_SOURCE_COLUMNS.scope}
                            </Text>
                        </th>
                        <th scope="col" className={headerCellStyle}>
                            <Text as="span" variant="info_txt_1">
                                {PRICES_HUB_DATA_SOURCE_COLUMNS.updateFrequency}
                            </Text>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {sources.map((source) => (
                        <tr key={source.source} className={rowStyle}>
                            <th scope="row" className={sourceCellStyle}>
                                <Text as="span" variant="body_copy_2">
                                    {source.source}
                                </Text>
                            </th>
                            <td className={cellStyle}>
                                <Text as="span" variant="body_copy_2">
                                    {source.shows}
                                </Text>
                            </td>
                            <td className={cellStyle}>
                                <Text as="span" variant="body_copy_2">
                                    {source.scope}
                                </Text>
                            </td>
                            <td className={cellStyle}>
                                <Text as="span" variant="body_copy_2">
                                    {source.updateFrequency}
                                </Text>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const frameStyle = css({
    width: "100%",
    /** Together with the table's 4px border-spacing this adds up to the 16px the design puts above the header. */
    pt: 1.5,
    overflow: "hidden",
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    boxShadow: "0 4px 10px 0 rgba(174, 177, 180, 0.3)"
});

/** The negative margins swallow the outer ring of border-spacing, so the rows reach the card edges. */
const tableStyle = css({
    width: "calc(100% + 0.8rem)",
    mx: "-0.4rem",
    mb: "-0.4rem",
    tableLayout: "fixed",
    borderCollapse: "separate",
    borderSpacing: "0.4rem"
});

const headerCellStyle = css({
    width: "25%",
    height: "3rem",
    px: 1,
    color: "var(--colors-gray-700)",
    textAlign: "center",
    fontWeight: 400,
    verticalAlign: "middle"
});

const cellStyle = css({
    height: "9.2rem",
    px: 1,
    color: "var(--colors-secondary)",
    textAlign: "center",
    verticalAlign: "middle"
});

const sourceCellStyle = css({
    height: "9.2rem",
    px: 1,
    color: "var(--colors-secondary)",
    textAlign: "center",
    fontWeight: 400,
    verticalAlign: "middle"
});

const rowStyle = css({
    "& > th, & > td": {
        backgroundColor: "var(--colors-gray-100)"
    },

    "&:nth-of-type(even) > th, &:nth-of-type(even) > td": {
        backgroundColor: "var(--colors-gray-200)"
    }
});
